module.exports = __webpack_public_path__ + "media/application/images/svgs/alert-octagon-893fc580308e119fd32a5c49cfea1099.svg";